"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17 10a7 7 0 11-14 0 7 7 0 0114 0zm-6-5v2H9V5h2zm0 3v6h1v1H8v-1h1V9H8V8h3z"];
//# sourceMappingURL=small-info-sign.js.map